const base_url = process.env.REACT_APP_API || "http://127.0.0.1:2342/";

export interface CommonOptions {
  meanType: string;
  zerosLeft: number;
  zerosRight: number;
  logScale: boolean;
  multiLabel: boolean;
}

export function downloadInputExample(): Promise<any> {
  const url = base_url + "getInputExample";
  return fetch(url, {
    // Your POST endpoint
    method: "POST",
  })
    .then((response) => response.blob())
    .then(
      (blob) => {
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", "msanalyzer_input_example.xps");
        document.body.appendChild(link);
        link.click();
        return blob;
      } // Handle the success response object
    );
}

export function isSeverAlive(): Promise<any> {
  return fetch(base_url)
    .then((r) => r.json())
    .catch((_e) => {
      return new Promise(() => true);
    });
}

export function sendSingleMode(
  file: File,
  options: CommonOptions
): Promise<any> {
  const url = base_url + "singleModeZip";
  const formData = new FormData();

  // file: UploadFile = File(...),
  // meanType: str = Form("geo"),
  // zerosLeft: int = Form(1),
  // zerosRight: int = Form(1),
  // logScale: bool = Form(True),
  // multiLabel: bool = Form(True),

  if (file) {
    formData.append("file", file);
    formData.append("meanType", options.meanType);
    formData.append("zerosLeft", options.zerosLeft.toString());
    formData.append("zerosRight", options.zerosRight.toString());
    formData.append("logScale", options.logScale.toString());
    formData.append("multiLabel", options.multiLabel.toString());

    return fetch(url, {
      method: "POST",
      body: formData,
    });
  }

  return new Promise(() => null);
}

export function sendMultiMode(
  files: File[],
  options: CommonOptions
): Promise<any> {
  const url = base_url + "multiModeZip";
  const formData = new FormData();

  files.forEach((file) => formData.append("files", file));
  formData.append("meanType", options.meanType);
  formData.append("zerosLeft", options.zerosLeft.toString());
  formData.append("zerosRight", options.zerosRight.toString());
  formData.append("logScale", options.logScale.toString());
  formData.append("multiLabel", options.multiLabel.toString());

  return fetch(url, {
    method: "POST",
    body: formData,
  });
}

export async function b64toBlob(b64Data: any): Promise<Blob> {
  const base64 = await fetch(b64Data);
  const blob = await base64.blob();

  return blob;
}
